
export const useErrorModal = () => {

    const errors = useState<{
        errors: Record<string, string[]>|undefined,
        errorDescription: string|undefined,
        retryMethod: (() => void)|undefined
    }|null>('errorModalErrors', () => null);

    const setErrors = (e: Record<string, string[]>, d?: string, m?: () => void) => {
        errors.value = {
            errors: e,
            errorDescription: d,
            retryMethod: m
        };
    }

    return {
        errors,
        setErrors,
    };
};